import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Box } from "@mui/material";
import { FormikProps } from "formik";
import dayjs, { Dayjs } from "dayjs";

interface DatePickerProps {
  name: string;
  label: string;
  formik: FormikProps<any>;
}

export default function DatePicker({ name, label, formik }: DatePickerProps) {
  const error = formik.touched[name] && Boolean(formik.errors[name]);
  const helperText = formik.touched[name] && formik.errors[name];

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            "&:hover fieldset": { borderColor: "#e53935" },
            "&.Mui-focused fieldset": { borderColor: "#e53935" },
          },
          "& .MuiInputLabel-root.Mui-focused": { color: "#e53935" },
          mt: 0,
          mb: 0,
        }}
      >
        <MuiDatePicker
          label={label}
          format="DD/MM/YYYY"
          value={formik.values[name] ? dayjs(formik.values[name]) : null}
          onChange={(date: Dayjs | null) => {
            formik.setFieldValue(name, date ? date.format("YYYY-MM-DD") : "");
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              size: "small",
              name,
              error,
              helperText: helperText as string,
              onBlur: formik.handleBlur,
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
